import { createBrowserHistory, createMemoryHistory } from 'history';
import { createRoot } from 'react-dom/client';

import config from 'config';
import { getStandAloneElement } from 'helpers';
import { getAccessStandAloneToken, setAccessToken } from 'services/auth';
import { newRelicService } from 'services/newrelic';
import { GlobalContextProvider } from 'store';

import App from './App';

import type {
  OnParentNavigationParams,
  MountFunctionOptions,
  MountFunctionReturn,
} from 'types/bootstrap.d';

// Initialize New Relic service
// injecting browser monitoring script.
if (process.env.NODE_ENV === 'development') {
  newRelicService.init();
}

const mount = (
  element: HTMLElement,
  { brand, initialPath, defaultHistory, reseller, document: documentParams }: MountFunctionOptions
): MountFunctionReturn => {
  const history = defaultHistory || createMemoryHistory({ initialEntries: [initialPath] });

  const root = createRoot(element!);

  root.render(
    <GlobalContextProvider state={{ user: reseller, brand: brand, document: documentParams }}>
      <App />
    </GlobalContextProvider>
  );

  return {
    onParentNavigation: ({
      pathname: nextPathname,
      search: nextSearch,
    }: OnParentNavigationParams) => {
      const currentPathname = history.location.pathname;
      const currentSearch = history.location.search;

      currentPathname !== nextPathname && history.push(nextPathname);
      currentSearch !== nextSearch && history.push(`${nextPathname}${nextSearch}`);
    },
  };
};

const standAloneElement = getStandAloneElement();

const isStandAloneMode = standAloneElement;

if (isStandAloneMode) {
  const token = getAccessStandAloneToken() || '';

  setAccessToken({ token });

  mount(standAloneElement, {
    brand: {
      short: config.app.slugname,
      sac: {
        whatsapp: '12 98837-0002',
        phone: '0800 744 2700',
        portalName: 'Regulariza Eudora',
        portalLink: 'https://regularizaeudora.com.br/',
        hours: {
          whatsapp: 'Segunda a sexta, das 08h às 20h40. Sábado, das 08h às 14h20.',
          phone: 'Segunda a sexta, das 08h às 20h40. Sábado, das 08h às 14h20.',
          portal: 'Atendimento 24 horas',
        },
      },
    },
    initialPath: window.location,
    defaultHistory: createBrowserHistory(),
    fallbackUrl: '/',
  });
}

const unMount = (element: HTMLElement | Element): Boolean => {
  return unmountComponentAtNode(element);
};

export { mount, unMount };
